import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { LocationEnvironment } from '../../interfaces/locations-environments';
import { CREATE_LOCATION_ENVIRONMENT_MUTATION, GET_LOCATION_ENVIRONMENT_QUERY, SEARCH_LOCATION_ENVIRONMENTS_QUERY, UPDATE_LOCATION_ENVIRONMENT_MUTATION } from './location-environment.query';
import { CreateLocationEnvironmentInput, SearchLocationEnvironmentParams, SearchLocationEnvironmentResult, UpdateLocationEnvironmentInput } from './location-environment.type';

@Injectable({
  providedIn: 'root',
})
export class LocationEnvironmentApi {
  public constructor(private readonly apollo: Apollo) {}

  public async get(id: string): Promise<LocationEnvironment | undefined> {
    return this.apollo.query<{ locationEnvironment: LocationEnvironment }>({
      query: GET_LOCATION_ENVIRONMENT_QUERY,
      variables: { id },
    }).toPromise()
      .then((response) => response.data && response.data.locationEnvironment);
  }

  public async search(params?: SearchLocationEnvironmentParams): Promise<SearchLocationEnvironmentResult> {
    return this.apollo.query<{ locationEnvironments: SearchLocationEnvironmentResult }>({
      query: SEARCH_LOCATION_ENVIRONMENTS_QUERY,
      variables: params,
    }).toPromise()
      .then((response) => response.data && response.data.locationEnvironments);
  }

  public async create(params: CreateLocationEnvironmentInput): Promise<LocationEnvironment | undefined> {
    return this.apollo.mutate<{ createLocationEnvironment: LocationEnvironment }>({
      mutation: CREATE_LOCATION_ENVIRONMENT_MUTATION,
      variables: { input: params },
    }).toPromise()
      .then((response) => response.data && response.data.createLocationEnvironment);
  }

  public async update(params: UpdateLocationEnvironmentInput): Promise<LocationEnvironment | undefined> {
    return this.apollo.mutate<{ updateLocationEnvironment: LocationEnvironment }>({
      mutation: UPDATE_LOCATION_ENVIRONMENT_MUTATION,
      variables: { input: params },
    }).toPromise()
      .then((response) => response.data && response.data.updateLocationEnvironment);

  }
}
